import React from 'react';
import { Card, Skeleton, Space } from 'antd';

export const CalendarSkeleton = () => {
  const daysOfWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

  return (
    <div className="calendar-skeleton" style={{ width: '100%', marginTop: 16 }}>
      {/* Calendar Toolbar */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          flexWrap: 'wrap',
          gap: 12
        }}
      >
        <Space size="middle">
          <Skeleton.Button active style={{ width: 140, height: 36, borderRadius: 4 }} />
          <Skeleton.Button active size="small" shape="circle" style={{ width: 32, height: 32 }} />
          <Skeleton.Button active size="small" shape="circle" style={{ width: 32, height: 32 }} />
          <Skeleton.Input active size="small" style={{ width: 120, height: 20, borderRadius: 4 }} />
        </Space>
        <Space size="small">
          <Skeleton.Button active style={{ width: 80, height: 32, borderRadius: 4 }} />
          <Skeleton.Button active style={{ width: 80, height: 32, borderRadius: 4 }} />
          <Skeleton.Button active style={{ width: 80, height: 32, borderRadius: 4 }} />
        </Space>
      </div>

      {/* Calendar Grid Card */}
      <Card bordered={false} bodyStyle={{ padding: 0 }} style={{ width: '100%', borderRadius: 6, overflow: 'hidden' }}>
        {/* Days Header */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            backgroundColor: '#fafafa',
            borderBottom: '1px solid #f0f0f0',
            textAlign: 'center',
            padding: '10px 0'
          }}
        >
          {daysOfWeek.map((day, idx) => (
            <div key={'dow_' + idx} style={{ fontWeight: 600, color: '#8c8c8c', fontSize: 13 }}>
              {day}
            </div>
          ))}
        </div>

        {/* 5 Weeks Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)' }}>
          {Array.from({ length: 35 }).map((_, idx) => (
            <div
              key={'cal_cell_' + idx}
              style={{
                minHeight: 100,
                borderRight: (idx + 1) % 7 === 0 ? 'none' : '1px solid #f0f0f0',
                borderBottom: idx >= 28 ? 'none' : '1px solid #f0f0f0',
                padding: '8px',
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
                backgroundColor: (idx % 7 === 5 || idx % 7 === 6) ? '#fafbfc' : '#ffffff'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Skeleton.Input active size="small" style={{ width: 18, height: 14, borderRadius: 2 }} />
              </div>
              {idx % 3 === 1 && (
                <Skeleton.Button
                  active
                  size="small"
                  style={{ width: '100%', height: 18, borderRadius: 3, marginTop: 4 }}
                />
              )}
              {idx % 4 === 2 && (
                <Skeleton.Button
                  active
                  size="small"
                  style={{ width: '85%', height: 18, borderRadius: 3 }}
                />
              )}
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default CalendarSkeleton;

